const stateChangesMap = new WeakMap<object, string[]>();

export default stateChangesMap;
